import React from "react";
import { Checkbox, Input } from "antd";
import {
  cardioChiefComplaintOptions,
  neuroChiefComplaintOptions,
  orthoChiefComplaintOptions,
  sportsChiefComplaintOptions,
} from "../OpPhysioOptions";

const toChiefComplaintsArray = (v) => {
  if (Array.isArray(v)) return v;
  if (v == null || v === "") return [];
  return [v];
};

const ChiefComplaintsForm = ({ onValuesChange, formData, formType }) => {
  const getOptions = () => {
    switch (formType) {
      case "cardio":
        return cardioChiefComplaintOptions;
      case "neuro":
        return neuroChiefComplaintOptions;
      case "ortho":
        return orthoChiefComplaintOptions;
      case "sports":
        return sportsChiefComplaintOptions;
      default:
        return [];
    }
  };

  const section = formData?.chief_complaint || {};
  const selected = toChiefComplaintsArray(section.chief_complaints);

  const updateSection = (partial) => {
    onValuesChange("chief_complaint", {
      ...section,
      ...partial,
    });
  };

  return (
    <div className="ip-forms" style={{ padding: "8px 0" }}>
      <div className="checkbox-grid" style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, fontWeight: 500 }}>Chief Complaints</div>
        <Checkbox.Group
          options={getOptions()}
          value={selected}
          onChange={(checkedValues) =>
            updateSection({ chief_complaints: checkedValues })
          }
        />
      </div>
      <Input.TextArea
        rows={3}
        placeholder="Comments"
        style={{ width: "60%" }}
        value={section.comments ?? ""}
        onChange={(e) => updateSection({ comments: e.target.value })}
      />
    </div>
  );
};

export default ChiefComplaintsForm;
